import { Metrics } from '@src/metrics/Metrics';

const COUNT_TYPE = 'com.amazon.ihmbees.coral#CountMetric';

/**
 *  Example ProgramName: 'IhmFlyingDutchman'
 *  Usage:
 *      var cMetric = new CountMetric(storeId, MetricName, ProgramName, Operation)
 *      cMetric.count(1);
 */
export class CountMetric extends Metrics {
    constructor(storeId, name, program, operation) {
        super(COUNT_TYPE, storeId, name, program, operation);
    }

    public count(value) {
        const currentTime = new Date().getTime();
        this.setStartTime(currentTime);
        this.setStopTime(currentTime);
        this.setValue(value);
        try {
            this.broadcastMetric();
        } catch (error) {
            console.error(error);
        }
    }
}
